import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '@/action';
import Navbar from './navbar/Navbar';
import FileList from './fileList/FileList';
import PreviewContent from './previewContent/PreviewContent';
import WorkPlace from './workplace/WorkPlace';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Utils from '@/utils/utils';
import { ReactComponent as Logo } from '@/assets/icons/logo-title.svg';
import { ReactComponent as Loadding } from '@/assets/images/timg.svg';
import { Drawer } from 'antd';
import PurchaseModal from '@/components/common/purchaseModal/PurchaseModal';

import LoginModal from '@/components/googleAndEmail/index';
import { withRouter } from 'react-router-dom';
import {
  requsetGetAnonymousSessions,
  requsetGetProfile,
  requsetGetSubscription,
  requsetGetAppearance,
  googleCallback,
} from '@/api/apis';
import PayBill from './common/payBill';
import Cookies from 'js-cookie';
import api_domain_config from '@/constants/common';
import sentGAEvent from '@/ga';
import '@/assets/home.scss';
import axios from 'axios';
import { loginWithToken } from '../api/apis';
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collspan: false,
      tipsClosed: false,
      show: false,
      init: false,
    };
    this.timer = null;

    // this.navbarRef = React.createRef();
  }
  handleCollspanClick = (e) => {
    if (this.state.collspan) {
      document.querySelector('.Stage .center').style.maxWidth =
        'calc(100% - 450px)';
    } else {
      document.querySelector('.Stage .center').style.maxWidth =
        'calc(100% - 280px)';
    }
    this.setState({ collspan: !this.state.collspan });
  };

  childrenHandleClose = (value) => {
    this.setState({ tipsClosed: value });
  };

  getQueryVariable(variable) {
    //拿链接参数
    const urlParams = window.location.href.split('?')[1];

    var vars = urlParams.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return false;
  }

  componentDidMount() {
    console.log(window.location.href.split('?')[1]);
    if (window.location.href.split('?')[1] !== undefined) {
      const code = this.getQueryVariable('code');
      const state = this.getQueryVariable('state');
      console.log(code, state);
      if (code && state) {
        googleCallback({ code: code, state: state }).then((obj) => {
          if (obj.code === 200) {
            Cookies.set('authorization', obj.data.authorization, {
              expires: 30,
            });
            let hostName = window.location.hostname;
            Cookies.set('access_token', obj.data.account_access_token, {
              expires: 30,
              domain: hostName.substring(
                hostName.indexOf('.'),
                hostName.length
              ),
            });
            let expires_in = new Date().getTime() + 30 * 86400 * 1000;
            Cookies.set('access_token_expires_in', expires_in.toString(), {
              expires: 30,
              domain: hostName.substring(
                hostName.indexOf('.'),
                hostName.length
              ),
            });
            this.props.onAuthorizationChange(obj.data.authorization);
            this.handleInitUserInfo();
            // this.getToken();
            this.handleInitWork();
            const timeOut = setTimeout(() => {
              this.setState({ init: true }); //触发重新渲染，确保能得到this.navbarRef.current的高
              clearTimeout(timeOut);
            }, 300);
          }
          if (obj.code === 403101) {
            this.props.onSignUpModal({
              visible: true,
              step: 6,
            });
            this.props.onSaveEmail({ email: obj.data.email });
            localStorage.setItem('googleId', obj.data.id);
          }
          if (obj.code === 403102) {
            this.props.onSignUpModal({
              visible: true,
              step: 2,
            });
          }
          this.props.history.push('/tools');
        });
      }
    } else {
      let authorization = Cookies.get('authorization');
      let access_token = Cookies.get('access_token');
      let expire_at = Cookies.get('access_token_expires_in');
      if (access_token && !authorization && expire_at) {
        let formdata = new FormData();
        formdata.append('account_token', access_token);
        formdata.append(
          'expire_at',
          Math.floor(Number(Cookies.get('access_token_expires_in')) / 1000)
        );
        loginWithToken(formdata).then((obj) => {
          if (obj.code === 200) {
            let hostname = window.location.hostname;
            Cookies.set('authorization', obj.data.authorization, {
              expires: 30,
            });
            Cookies.set('access_token', obj.data.account_access_token, {
              expires: 30,
              domain: hostname.substring(
                hostname.indexOf('.'),
                hostname.length
              ),
            });
            let expires_in = new Date().getTime() + 30 * 86400 * 1000;
            Cookies.set('access_token_expires_in', expires_in.toString(), {
              expires: 30,
              domain: window.location.hostname.substring(
                window.location.hostname.indexOf('.'),
                window.location.hostname.length
              ),
            });
            this.props.onAuthorizationChange(obj.data.authorization);
            this.props.isLogin({ value: true });
          }
        });
      }
    }

    this.handleInitUserInfo();
    // this.getToken();
    this.handleInitWork();
    const timeOut = setTimeout(() => {
      this.setState({ init: true }); //触发重新渲染，确保能得到this.navbarRef.current的高
      clearTimeout(timeOut);
    }, 300);
  }

  componentDidUpdate(PrevProps) {
    if (
      PrevProps.userInfo.userinfo.isLogin.value !==
      this.props.userInfo.userinfo.isLogin.value
    ) {
      if (this.props.userInfo.userinfo.isLogin.value) {
        // this.props.onChangeIsLogin(false);
        this.handleInitUserInfo();
        // this.getToken();
        this.handleInitWork();
      }
    }
    if (
      PrevProps.purchaseModalObj.visible !==
        this.props.purchaseModalObj.visible &&
      !this.props.purchaseModalObj.visible
    ) {
      if (Cookies.get('authorization')) {
        this.getAppearance();
        this.getProfile();
        this.getSubscription();
      }
    }
  }

  /**
   * 用户进来本页面，登录流程
   */
  handleInitUserInfo = () => {
    //如果当前内存中没有 authorization, 则是说明没有登录，直接获取token用作路人身份
    if (!Cookies.get('authorization')) {
      this.getToken();
      window.Storage.remove('theme');
      this.props.onThemeChange('dark');
    } else {
      if (Cookies.get('anonymousAuth')) {
        Cookies.remove('anonymousAuth', { domain: api_domain_config.DOMAIN });
        Cookies.remove('videoEditorTimes', {
          domain: api_domain_config.DOMAIN,
        });
      }

      this.getAppearance();
      this.getProfile();
      this.getSubscription();
    }
  };

  /**
   * 获取url中的参数，设置当前work区块
   */
  handleInitWork = () => {
    let currWork = '';
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('work') && !urlParams.has('blob')) {
      currWork = urlParams.get('work');
      // window.history.replaceState({}, document.title, window.location.origin);
      // window.history.replaceState({}, document.title, window.location.pathname);
      window.history.replaceState(
        {},
        document.title,
        window.location.origin + window.location.pathname
      );
    } else {
      currWork = localStorage.getItem('currWork');
    }
    if (currWork) {
      this.props.onWorkChange(currWork);
      localStorage.setItem('currWork', currWork);
    }
    if (urlParams.has('source')) {
      localStorage.setItem('toolsSource', urlParams.get('source'));
    } else {
      if (!localStorage.getItem('toolsSource')) {
        localStorage.setItem('toolsSource', 'other');
      }
    }
    sentGAEvent({
      category: 'FuncRate',
      action: 'PageEnter',
      label: Utils.getLanguage() + '_' + (currWork || this.props.work),
    });
    let gacurrWork = localStorage.getItem('currGa');
    sentGAEvent({
      category: 'EnterFuncPage',
      action: gacurrWork + '_EnterFuncPage',
    });
  };

  /**
   * 请求获取用户个人信息
   */
  getProfile = () => {
    requsetGetProfile()
      .then((res) => {
        if (res.code === 200) {
          this.setState({ show: true });
          this.props.onProfileObjChange(res.data);
        } else {
          // localStorage.removeItem("authorization");
          this.getToken();
        }
      })
      .catch((err) => {
        this.getToken();
      });
  };
  hrefToPurchase = (url) => {
    let winRef;
    let targetUrl;

    // 延迟1000ms
    setTimeout(() => {
      winRef = window.open(targetUrl, '_blank');
    }, 1000);

    axios
      .post(url, {
        a: 'a',
      })
      .then((res) => {
        // 判断winRef是否有值，如有则已打开了新窗口，则将新窗口地址置为url
        // 否则将url赋给targetUrl即可
        if (winRef) {
          winRef.location.href = url;
        } else {
          targetUrl = url;
        }
      })
      .catch((err) => {
        if (winRef) {
          winRef.location.href = url;
        } else {
          targetUrl = url;
        }
      });
  };
  /**
   * 请求获取用户订阅信息
   */
  getSubscription = () => {
    requsetGetSubscription()
      .then((res) => {
        if (res.code === 200) {
          if (res.data.subscription == null) {
            this.props.onSubscriptionChange('isUnSubscription');
          } else {
            this.props.onSubscriptionChange(res.data.subscription[0]);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  /**
   * 请求获取用户主题信息
   */
  getAppearance = () => {
    requsetGetAppearance()
      .then((res) => {
        if (res.code === 200) {
          let theme = res.data.appearance === 'Light' ? 'light' : 'dark';
          document.documentElement.setAttribute('data-theme', theme);
          window.Storage.set('theme', theme);
          console.log('用户主题', res);
          this.props.onThemeChange(theme);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  componentWillUnmount() {
    clearInterval(this.timer);
    this.setState = () => false;
  }
  /**
   * 获取Token
   */
  getToken = () => {
    if (!Cookies.get('anonymousAuth')) {
      requsetGetAnonymousSessions()
        .then((res) => {
          Cookies.set('anonymousAuth', res.data.authorization, {
            expires: 1,
            domain: api_domain_config.DOMAIN,
          });
          Cookies.set('videoEditorTimes', 0, {
            expires: 1,
            domain: api_domain_config.DOMAIN,
          });
          this.props.onAuthorizationChange(res.data.authorization);
          this.props.onVideoEditorTimesChange(0);
          this.setState({ show: true });
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      this.props.onTokenIdChange(window.Storage.get('tokenId'));
      this.setState({ show: true });
    }
  };

  render() {
    return (
      <div className='Home'>
        <div className='Mobile-top-navbar'>
          <a href={Utils.getHitPawLink()}>
            <svg
              style={{ display: 'block' }}
              width='36'
              height='36'
              viewBox='0 0 36 36'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M21 10L13 18L21 26'
                stroke='currentColor'
                strokeOpacity='0.8'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </a>
          <a href={Utils.getHitPawHomeLink()} className='logo'>
            <Logo style={{ display: 'block' }} />
          </a>
          <a
            href={
              this.props.work === 'removeWatermark'
                ? Utils.getHitPawWatermarkRemoverEXELink()
                : window.userClient.platform === 'win'
                ? Utils.getHitPawVideoEditorEXELink()
                : Utils.getHitPawToolKitEXELink()
            }
            target='_blank'
            rel='noopener noreferrer'
            style={{ visibility: 'hidden' }}
          >
            <svg
              width='40'
              height='40'
              viewBox='0 0 40 40'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <rect
                x='10'
                y='11'
                width='20'
                height='15'
                rx='1'
                stroke='currentcolor'
                strokeWidth='1.86667'
              />
              <path
                d='M19.5 15.5V21.5M19.5 21.5L17 19M19.5 21.5L22 19'
                stroke='currentcolor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M26 31L14 31'
                stroke='currentcolor'
                strokeWidth='2'
                strokeLinecap='round'
              />
            </svg>
          </a>
        </div>
        <Navbar />
        <PayBill />
        <DndProvider backend={HTML5Backend}>
          {this.state.show ? (
            <div className='Stage'>
              <div>
                <FileList />
              </div>
              <div
                className={`center ${
                  this.props.work && !this.props.successFileGuids.length
                    ? 'open'
                    : ''
                }`}
              >
                <PreviewContent />
              </div>
              {document.body.clientWidth <= 992 ? (
                <div
                  className='right'
                  style={this.props.prevWork ? { display: 'none' } : {}}
                >
                  <WorkPlace />
                </div>
              ) : (
                <Drawer
                  visible={this.props.work}
                  closable={false}
                  mask={false}
                  getContainer={false}
                  style={
                    this.props.successFileGuids.length
                      ? { display: 'none' }
                      : {}
                  }
                  className='pc-workplace'
                  placement={this.props.lang === 'ar' ? 'left' : 'right'}
                >
                  <div
                    className='right'
                    style={this.props.prevWork ? { display: 'none' } : {}}
                  >
                    <WorkPlace />
                  </div>
                </Drawer>
              )}
            </div>
          ) : (
            <div className='Loadding-cont'>
              <Loadding />
            </div>
          )}

          <LoginModal />
          <PurchaseModal />
        </DndProvider>
      </div>
    );
  }
}

const mapStateToPropos = (state) => ({
  work: state.work.work,
  prevWork: state.work.prevWork,
  successFileGuids: state.files.successFileGuids,
  authorization: state.common.authorization,
  theme: state.common.theme,
  purchaseModalObj: state.common.purchaseModalObj,
  signUpModal: state.common.signUpModal,
  subscription: state.common.subscription,
  userInfo: state,
});
const mapDispatchToProps = (dispatch) => ({
  onSaveEmail: (email) => dispatch(actions.saveEmail(email)),
  onWorkChange: (work) => dispatch(actions.onWorkChange(work)),
  onTokenIdChange: (tokenId) => dispatch(actions.onTokenIdChange(tokenId)),
  onAuthorizationChange: (authorization) =>
    dispatch(actions.onAuthorizationChange(authorization)),
  onProfileObjChange: (profileObj) =>
    dispatch(actions.onProfileObjChange(profileObj)),
  onSubscriptionChange: (subscription) =>
    dispatch(actions.onSubscriptionChange(subscription)),
  onThemeChange: (theme) => dispatch(actions.onThemeChange(theme)),
  onVideoEditorTimesChange: (videoEditorTimes) =>
    dispatch(actions.onVideoEditorTimesChange(videoEditorTimes)),
  onChangeIsLogin: (value) => dispatch(actions.isLogin(value)),
  onPurchaseModalObjChange: (purchaseModalObj) =>
    dispatch(actions.onPurchaseModalObjChange(purchaseModalObj)),
  onSignUpModal: (signUpModal) => dispatch(actions.onSignUpModal(signUpModal)),
  isLogin: (isLogin) => dispatch(actions.isLogin(isLogin)),
});

export default connect(mapStateToPropos, mapDispatchToProps)(withRouter(Home));
